/*global Modernizr, Splide, DDSlideCurrentSlide, DDSlideHideArrows, DDSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var testimonials_containers = document.querySelectorAll('.testimonials-container');
    if(testimonials_containers) {
      testimonials_containers.forEach((testimonials_container) => {
        const testimonial_slider = testimonials_container.querySelector('.testimonial-slider');
        const testimonial_image_slider = testimonials_container.querySelector('.testimonial-image-slider');

        const main = new Splide(testimonial_slider, {
          type: 'loop',
          rewind: true,
          pagination: false
        });

        const thumbnails = new Splide(testimonial_image_slider, {
          rewind: true,
          isNavigation: true,
          gap: 20,
          pagination: false,
          arrows: false
        });

        main.on('mounted resize', () => {
          if(main.length <= main.options.perPage) {
            testimonial_slider.parentElement.classList.add('no-paging');
            main.root.querySelector('.splide__arrows').classList.add('hidden');
          } else {
            testimonial_slider.parentElement.classList.remove('no-paging');
            main.root.querySelector('.splide__arrows').classList.remove('hidden');
          }
        });

        main.sync( thumbnails );
        main.mount({ DDSlideCurrentSlide, DDSlideHideArrows, DDSlideDisableDrag });
        thumbnails.mount();
      });
    }
}());
